import React, { useState } from 'react';
import { Upload, Button, Space, Typography, Alert, message } from 'antd';
import { InboxOutlined, DownloadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';

const { Text } = Typography;

// Parse XLSX ou CSV client-side. Case-insensitive nos headers.
// Aceita colunas: nome/name, telefone/phone, email, valor/amount.
function normalizeRow(row, defaultAmount) {
  const lower = {};
  for (const k of Object.keys(row)) lower[k.toLowerCase().trim()] = row[k];
  const name = String(lower['nome'] || lower['name'] || '').trim();
  const phone = String(lower['telefone'] || lower['phone'] || '').replace(/\D/g, '').trim();
  const email = String(lower['email'] || '').trim();
  const rawAmount = lower['valor'] ?? lower['amount'];
  let amount_brl = defaultAmount;
  if (rawAmount != null && rawAmount !== '') {
    const n = Number(String(rawAmount).replace(',', '.'));
    if (!isNaN(n) && n > 0) amount_brl = n;
  }
  return { name, phone, email, amount_brl };
}

export default function ExcelUploader({ onParsed, defaultAmount = 50 }) {
  const [parseInfo, setParseInfo] = useState(null); // {total, valid, invalid, recipients}

  const beforeUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const wb = XLSX.read(data, { type: 'array' });
        const sheet = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' });
        const parsed = rows.map(r => normalizeRow(r, defaultAmount));
        const valid = parsed.filter(r => r.name && (r.email || r.phone));
        setParseInfo({
          total: parsed.length,
          valid: valid.length,
          invalid: parsed.length - valid.length,
          recipients: valid,
        });
        onParsed?.(valid);
        message.success(`Importado: ${valid.length} válidos`);
      } catch (err) {
        message.error('Falhou ler arquivo: ' + err.message);
      }
    };
    reader.readAsArrayBuffer(file);
    return false; // impede upload real
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Button icon={<DownloadOutlined />} href="/futezap-cobranca-modelo.csv" download>
        Baixar modelo CSV
      </Button>
      <Upload.Dragger accept=".xlsx,.xls,.csv" beforeUpload={beforeUpload} multiple={false} showUploadList={false}>
        <p className="ant-upload-drag-icon"><InboxOutlined /></p>
        <p className="ant-upload-text">Arraste ou clique pra escolher arquivo</p>
        <p className="ant-upload-hint">
          Aceita xlsx, xls, csv. Header: nome, telefone, email, valor.
          Linhas sem nome ou sem email/telefone são ignoradas.
        </p>
      </Upload.Dragger>
      {parseInfo && (
        <Alert
          type={parseInfo.valid > 0 ? 'success' : 'warning'}
          showIcon
          message={`Importado: ${parseInfo.valid} válidos${parseInfo.invalid > 0 ? `, ${parseInfo.invalid} ignorados (sem nome/contato ou valor inválido)` : ''}`}
        />
      )}
    </Space>
  );
}
